class DomReadMore extends HTMLElement {
  connectedCallback() {
    this.fullContent = this.querySelector('.read-more__full-description')
    this.readMore = this.querySelector('.read-more__show')
    this.readLess = this.querySelector('.read-more__hide')
    this.toggle = this.toggle.bind(this)

    this.readMore.addEventListener('click', this.toggle)
    this.readLess.addEventListener('click', this.toggle)
  }
  disconnectedCallback() {
    this.readMore.removeEventListener('click', this.toggle)
    this.readLess.removeEventListener('click', this.toggle)
  }

  toggle = () => {
    this.readMore.classList.toggle('hidden')
    this.readLess.classList.toggle('hidden')
    this.fullContent.classList.toggle('hidden')
  }
}
customElements.define('dom-read-more', DomReadMore)
